import { ApiCore } from '@/services/api/utils/core.js'
import { handleError, handleResponse } from '@/services/api/utils/response.js'
import axios from 'axios'
import { apiProvider } from '@/services/api/utils/provider.js'
import { omit } from 'lodash'

const url = 'principal'
const plural = 'principals'
const single = 'principal'

const api = new ApiCore({
	index: true,
	findOne: false,
	create: true,
	update: false,
	remove: true,
	url: url,
	plural: plural,
	single: single
})

api.delete = (params) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}`, {data: params})
		.then(handleResponse)
		.catch(handleError);
}

api.getEditEnrollmentPrincipal = ({ params }) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${params.useCaseId}/${params.dataElementId}/${params.type}/${params.systemId}`)
		.then(handleResponse)
		.catch(handleError);
}

api.getSubscriptionPrincipal = ({ params }) => {
    return axios
        .get(`${apiProvider.BASE_URL}/${url}/enrolmentprincipal/${params.useCaseId}/${params.dataElementId}/${params.type}/${params.participantId}`, { params: omit(params, ['useCaseId', 'dataElementId', 'type', 'participantId']) })
        .then(handleResponse)
        .catch(handleError);
}

api.getEnrolledPrincipals = ({ params }) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${single}/${params.orgId}`, { params: omit(params, ['orgId']) })
		.then(handleResponse)
		.catch(handleError);
}



export default api
